export default {
    aggregationType: 'SUM',
    valueType: 'NUMBER',
}
